module.exports = __webpack_public_path__ + "img/Practical.781ee8e3.svg";